export default "__VITE_ASSET__B8Pn5VCt__"